import { resolveDesignSystem, type DesignSystem } from "@repo/types"
import { safeGetItem, safeSetItem } from "../../lib/utils/localStorage"

const STORAGE_KEY = "design-system"

/** Dernier système de design connu (évite un flash du style par défaut au chargement). */
export const readCachedDesignSystem = (): DesignSystem => resolveDesignSystem(safeGetItem(STORAGE_KEY))

/** Applique le système de design à la page : html[data-ds="fluent"|"polaris"] active le style choisi (voir globals.css). */
export function applyDesignSystem(designSystem: DesignSystem, root: HTMLElement = document.documentElement): void {
  if (designSystem === "default") root.removeAttribute("data-ds")
  else root.setAttribute("data-ds", designSystem)
  safeSetItem(STORAGE_KEY, designSystem)
}
